import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './components/App';

import registerServiceWorker from './registerServiceWorker';

import { ApolloProvider } from 'react-apollo/';
import { Provider } from 'mobx-react';

import { PostStore } from './stores/PostStore';
import { StreamStore } from './stores/StreamStore';
import client from './client';

import 'tachyons';
import 'font-awesome/css/font-awesome.css';
import './themes/index.css';

let pstore = (window as any).postStore = new PostStore();

const stores = {
    postStore: pstore,
    streamStore: new StreamStore(),
};

ReactDOM.render(
    <Provider {...stores}>
        <ApolloProvider client={client}>
            <App />
        </ApolloProvider>
    </Provider>,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx